module.exports = __webpack_public_path__ + "img/$300.97cfbeef.svg";